import { ReactNode } from "react";
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize } from "@components/new/Button";
import { H4, Title3 } from "@components/new/Typo";
import NoDataImg from '@assets/img/no-data.png';
import styles from "./NoData.module.scss";

export interface INoDataProps {
  title: string;
  description?: ReactNode;
  btnTitle?: string;
  btnDisabled?: boolean;
  onClick?: () => void;
  width?: string;
  footer?: ReactNode;
}

export const NoData = ({ title, description, btnTitle, btnDisabled, onClick, width, footer }: INoDataProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ width }}>
        <img src={NoDataImg} alt=""/>
        <div className={styles.title}>
          <H4>{title || t("common.notFound")}</H4>
          {description ? (
            <Title3 color="sade-black">{description}</Title3>
          ) : null}
        </div>
        {btnTitle ? (
          <Button
            size={ButtonSize.L}
            onClick={onClick}
            title={btnTitle}
            disabled={btnDisabled}
            isWide
          />
        ) : null}
        {footer}
      </div>
    </div>
  )
}
